import React, { useEffect, useState } from "react"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  change,
  Field,
  formValueSelector,
  getFormSyncErrors,
  isDirty,
  reset,
} from "redux-form"
import { SingleSelectField, TextField } from "components/RenderInput"
import { getStripePrices, resetStripePrices } from "store/actions"
import UnsavedAlertModal from "components/UnsavedAlertModal"

const ProductInfoTab = ({
  productType,
  stripeProducts,
  getStripePrices,
  stripePrices,
  resetStripePrices,
  change,
  stripeProduct,
  isDirty,
  resetForm,
  tabIsActive,
  handleSave,
  formSyncErrors,
  isTPProduct,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (
      !tabIsActive &&
      isDirty &&
      (!formSyncErrors || Object?.keys(formSyncErrors)?.length === 0)
    ) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  useEffect(() => {
    return () => {
      resetStripePrices()
    }
  }, [])

  useEffect(() => {
    if (stripeProduct) {
      getStripePrices({ stripe_product_id: stripeProduct })
    }
  }, [stripeProduct])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>PRODUCT INFO</h4>
        </CardHeader>
        <CardBody>
          {productType === "2" ? (
            <>
              <Row>
                <Col xs="auto" className="mt-2">
                  <label>Stripe Product:</label>
                </Col>
                <Col xs="auto">
                  <div style={{ minWidth: "350px" }}>
                    <Field
                      name="stripeProduct"
                      component={SingleSelectField}
                      options={stripeProducts?.data?.map(product => ({
                        value: product?.id,
                        label: product?.name,
                      }))}
                      placeholder="Select Stripe Product"
                      onChange={(event, value) => {
                        if (value) {
                          change(
                            "info.name",
                            stripeProducts?.data?.find(
                              item => item?.id === value
                            )?.name
                          )
                          // getStripePrices({ stripe_product_id: value })
                        }
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs="auto" className="mt-2" style={{ minWidth: "119px" }}>
                  <label>Stripe Price:</label>
                </Col>
                <Col xs="auto">
                  <div style={{ minWidth: "350px" }}>
                    <Field
                      name="stripePrice"
                      component={SingleSelectField}
                      options={
                        stripePrices?.data?.map(item => ({
                          value: item?.id,
                          label: `$${item?.unit_amount / 100}`,
                        })) || []
                      }
                      placeholder="Select Stripe Price"
                      onChange={(event, value) => {
                        if (value) {
                          change(
                            "info.price",
                            stripePrices?.data?.find(item => item?.id === value)
                              ?.unit_amount / 100
                          )
                        }
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col xs="auto" className="mt-2" style={{ minWidth: "80px" }}>
                  <label>Name:</label>
                </Col>
                <Col xl={6}>
                  <Field
                    name="name"
                    component={TextField}
                    disabled={isTPProduct}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col xs="auto" className="mt-2">
                  <label>Price($):</label>
                </Col>
                <Col xl={6}>
                  <Field
                    name="price"
                    component={TextField}
                    type="number"
                    step="0.01"
                    min="0"
                    disabled={isTPProduct}
                  />
                </Col>
              </Row>
            </>
          )}
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.PRODUCT)

const mapStateToProps = state => ({
  productType: selector(state, "type.productType"),
  stripeProduct: selector(state, "info.stripeProduct"),
  stripeProducts: state.ProductsAndSubscriptions.stripeProducts,
  stripePrices: state.ProductsAndSubscriptions.stripePrices,
  isDirty: isDirty(FORM_NAMES.PRODUCT)(state, ...["info"]),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.PRODUCT)(state),
})

const mapDispatchToProps = dispatch => ({
  getStripePrices: values => dispatch(getStripePrices(values)),
  resetStripePrices: () => dispatch(resetStripePrices()),
  change: (field, value) =>
    dispatch(change(FORM_NAMES.PRODUCT, `${field}`, value)),
  resetForm: () => dispatch(reset(FORM_NAMES.PRODUCT)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductInfoTab)
